export default __webpack_public_path__ + "static/media/g-logoUniversidadMaderas.e65266f2.svg";